module.exports = __webpack_public_path__ + "media/images/resource-types/external-a604a1abca80f2533d084b816384a224.svg";